
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotional-banner",
      function () {
        return require("private-next-pages/promotional-banner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotional-banner"])
      });
    }
  